'use client';

import type { CreateCustomerSessionInput } from '@/app/api/customer-session/route';
import { swrMutationFetcher } from '@/utils/swr-utils';
import { HTTPError } from '@sales-domain/http-errors';
import type { Key } from 'swr';
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation';

export function useCreateAuthorizedCustomerSession({
  onError,
}: SWRMutationConfiguration<
  { customerSession: { id: string } },
  HTTPError,
  Key,
  CreateCustomerSessionInput
> = {}) {
  const {
    trigger: createCustomerSession,
    isMutating: isCreatingCustomerSession,
    error: errorCreatingCustomerSession,
  } = useSWRMutation<
    { customerSession: { id: string } },
    HTTPError,
    Key,
    CreateCustomerSessionInput
  >('/api/customer-session', swrMutationFetcher, {
    populateCache: true,
    // Since the API already returns the created customer session,
    // we don't need to revalidate here.
    revalidate: false,
    throwOnError: false,
    onError,
  });
  return {
    createCustomerSession,
    isCreatingCustomerSession,
    errorCreatingCustomerSession,
  };
}
